var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1269_18868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85311 16.8824C8.85311 16.8824 7.70605 16.8824 7.70605 15.7353C7.70605 14.5883 8.85311 11.1471 13.4413 11.1471C18.0296 11.1471 19.1766 14.5883 19.1766 15.7353C19.1766 16.8824 18.0296 16.8824 18.0296 16.8824H8.85311ZM13.4413 10C14.354 10 15.2293 9.63748 15.8746 8.99213C16.52 8.34679 16.8825 7.47151 16.8825 6.55885C16.8825 5.6462 16.52 4.77092 15.8746 4.12557C15.2293 3.48023 14.354 3.11768 13.4413 3.11768C12.5287 3.11768 11.6534 3.48023 11.0081 4.12557C10.3627 4.77092 10.0002 5.6462 10.0002 6.55885C10.0002 7.47151 10.3627 8.34679 11.0081 8.99213C11.6534 9.63748 12.5287 10 13.4413 10Z",
    fill: "#464E5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8063 16.8823C6.63626 16.5242 6.55145 16.1316 6.55854 15.7352C6.55854 14.1809 7.33854 12.5808 8.77924 11.4682C8.06014 11.2466 7.31095 11.1382 6.55854 11.147C1.9703 11.147 0.823242 14.5882 0.823242 15.7352C0.823242 16.8823 1.9703 16.8823 1.9703 16.8823H6.8063Z",
    fill: "#464E5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M5.98483 9.99994C6.74538 9.99994 7.47478 9.69782 8.01257 9.16003C8.55036 8.62224 8.85248 7.89284 8.85248 7.1323C8.85248 6.37175 8.55036 5.64235 8.01257 5.10456C7.47478 4.56677 6.74538 4.26465 5.98483 4.26465C5.22429 4.26465 4.49489 4.56677 3.9571 5.10456C3.41931 5.64235 3.11719 6.37175 3.11719 7.1323C3.11719 7.89284 3.41931 8.62224 3.9571 9.16003C4.49489 9.69782 5.22429 9.99994 5.98483 9.99994Z",
    fill: "#464E5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1269_18868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3529,
    height: 18.3529,
    fill: "white",
    transform: "translate(0.823242 0.823486)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeIcon);
export default __webpack_public_path__ + "static/media/employee-icon.8d556b32ca367b87f49a409191c6bc8e.svg";
export { ForwardRef as ReactComponent };